import React from 'react'
import './About.css'
import ME from '../../assets/me-about.jpg'
import {FaAward,FaUsers} from 'react-icons/fa'
import {VscFolderOpened} from 'react-icons/vsc'

function About() {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>
    <div className="container about_container">
      <div className="about_me">
        <div className="about_me-image">
          <img src={ME} alt="About ME" />
        </div>
      </div>

      <div className="about_content">
        <div className="about_cards">
          <article className='about_card'>
            <FaAward className='about_icon'/>
            <h5>Experience</h5>
            <small>3+ Years Working</small>

          </article>

          <article className='about_card'>
            <FaUsers className='about_icon'/>
            <h5>Clients</h5>
            <small>200+ clients</small>

          </article>

          <article className='about_card'>
            <VscFolderOpened className='about_icon'/>
            <h5>Projects</h5>
            <small>80+ Projects</small>

          </article>
        </div>
        <p>I have experience in Front End and backend development. My role is to write and style the front-end components that 
          meet the requirements of our mocks and fulfill our user stories. I also monitor and process pull 
          requests for production deployments. Technologies used: django,wordpress, react.js, JavaScript, ES6,
          TypeScript, SASS.
          Skilled in Python, Microsoft PowerPoint, Communication, and Public Speaking.
          GitHub: <a href='https://github.com/noorshanu' target="__noor">https://github.com/noorshanu</a></p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
      </div>
    </div>

    </section>
  )
}

export default About